import { AxiosError } from 'axios';
import instance from '../config/axios';

export const clearNotificationInbox = async (
  token: string,
  notificationIds: Array<string>,
) => {
  try {
    const response = await instance.put(
      '/api/v1/patient/notifications/clear',
      { notificationIds },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (err) {
    console.error(err);
    return (err as AxiosError).response?.status as number;
  }
};
